module.exports = __webpack_public_path__ + "static/media/overlay.2ac78edb.png";